import { NavLink } from 'react-router-dom';

const NAV = [
  { to: '/admin',              label: 'Dashboard',     icon: '⊞' },
  { to: '/admin/submissions',  label: 'Submissions',   icon: '◉' },
  { to: '/admin/global',       label: 'Global / Brand', icon: '◈' },
  { to: '/admin/navigation',   label: 'Navigation',    icon: '☰' },
  { to: '/admin/hero',         label: 'Hero',          icon: '▶' },
  { to: '/admin/benefits',     label: 'Benefits',      icon: '✦' },
  { to: '/admin/howitworks',   label: 'How It Works',  icon: '⟳' },
  { to: '/admin/features',     label: 'Features',      icon: '⚡' },
  { to: '/admin/industries',   label: 'Industries',    icon: '⊙' },
  { to: '/admin/pricing',      label: 'Pricing',       icon: '$' },
  { to: '/admin/faq',          label: 'FAQ',           icon: '?' },
  { to: '/admin/contact',      label: 'Contact',       icon: '✉' },
  { to: '/admin/footer',       label: 'Footer',        icon: '▼' },
];

export default function AdminSidebar() {
  return (
    <aside className="adm-sidebar">
      <div className="adm-sidebar__brand">
        <img src="/klaivox_icon_zoomed_2x.svg" alt="Klaivox" className="adm-sidebar__logo" />
        <span className="adm-sidebar__name">Klaivox</span>
      </div>

      <nav className="adm-sidebar__nav">
        {NAV.map(({ to, label, icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/admin'}
            className={({ isActive }) =>
              `adm-sidebar__link${isActive ? ' adm-sidebar__link--active' : ''}`
            }
          >
            <span className="adm-sidebar__icon">{icon}</span>
            <span>{label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
